<script>
import CondusefProductForm from "@components/support-areas/internal-control/condusef/condusef-product-form.vue";
import SepomexAddressForm from "@components/support-areas/internal-control/condusef/sepomex-address-form.vue";
import Datepicker from "vuejs-datepicker";
import {es} from "vuejs-datepicker/dist/locale";
import {
  attentionLevels,
  channels,
  complaintAnswers,
  complaintStatus,
  genders, penalties, personTypes,
  pori
} from "@/helpers/complaits/catalogs";

export default {
  name: "requests-form",
  components: {
    CondusefProductForm,
    SepomexAddressForm,
    Datepicker
  },
  data: () => ({
    es,
    channels,
    attentionLevels,
    pori,
    complaintStatus,
    genders,
    complaintAnswers,
    penalties,
    personTypes,
    errorMessage: "",
    form: {
      noTrim: null,
      num: 1,
      folio: "",
      estatus: 1,
      fecAtencion: null,
      estadosId: null,
      fecRecepcion: "",
      medioId: 1,
      producto: "",
      causaId: 1,
      cp: null,
      munId: null,
      locId: null,
      colId: null,
      nivelATId: null,
      pori: "NO"
    },
  }),
  methods: {
    productsChangedHandler(form) {
      this.form.producto = form.product;
      this.form.causaId = form.causaId;
    },
    async submitComplaint() {
      this.errorMessage = "";
      try {
        await axios.post('/api/condusef/reune/request', this.form)
        this.$vs.notify({
          title: "Éxito",
          text: "Queja registrada",
          color: "success",
          iconPack: "feather",
          icon: "icon-check"
        });
      } catch (e) {
        if (e.response.status === 422) {
          this.errorMessage = e.response.data.errors;
          return;
        }

        this.$vs.notify({
          title: "Error",
          text: "Hubo un error al registrar la consulta",
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-circle"
        });
        this.errorMessage = e.response.data.error;
      }
    },
    addressChangedHandler(address) {
      this.form.locId = address.locId;
      this.form.cp = address.cp;
      this.form.estadosId = address.estadosId;
      this.form.munId = address.munId;
      this.form.colId = address.colId;
    }
  }
}
</script>

<template>
  <div>
    <span class="text-sm text-danger">{{ errorMessage }}</span>
    <div class="flex gap-4">
      <div class="w-6/12">
        <condusef-product-form
            variant="reune"
            for="for_requests"
            @onChange="productsChangedHandler"/>
        <vx-card title="Datos de la consulta" class="mt-3">
          <div class="grid grid-cols-3 gap-4">
            <vs-input class="w-full" label="Folio" v-model="form.folio"/>
            <vs-select class="w-full" label="Trimestre" v-model="form.noTrim">
              <vs-select-item
                  v-for="trim in [{id: 1, name: 'Enero-Marzo'}, {id: 2, name: 'Abril-Junio'}, {id: 3, name: 'Julio-Septiembre'}, {id: 4, name: 'Octubre-Diciembre'}]"
                  :key="trim.id"
                  :value="trim.id"
                  :text="trim.name"/>

            </vs-select>
            <vs-input class="w-full" label="Numero de consultas" v-model="form.num"/>
            <vs-input type="date" label="F. de recepción" class="w-full" v-model="form.fecRecepcion"/>

            <vs-select class="w-full" label="Medio" v-model="form.medioId">
              <vs-select-item
                  v-for="channel in channels"
                  :key="channel.id"
                  :value="channel.id"
                  :text="channel.name"/>
            </vs-select>
            <vs-select class="w-full" label="Nivel de atención" v-model="form.nivelATId" v-if="form.estatus === 2">
              <vs-select-item
                  v-for="attentionLevel in attentionLevels"
                  :key="attentionLevel.id"
                  :value="attentionLevel.id"
                  :text="attentionLevel.name"/>
            </vs-select>
            <vs-select class="w-full" label="PORI" v-model="form.pori">
              <vs-select-item
                  v-for="p in pori"
                  :key="p.id"
                  :value="p.id"
                  :text="p.name"/>
            </vs-select>
            <vs-select class="w-full" label="Estatus" v-model="form.estatus">
              <vs-select-item
                  v-for="status in complaintStatus"
                  :key="status.id"
                  :value="status.id"
                  :text="status.name"/>
            </vs-select>
            <vs-input
                type="date"
                class="w-full"
                label="F. de Atención"
                v-model="form.fecAtencion"
                v-if="form.estatus === 2"/>
          </div>
        </vx-card>
      </div>
      <div class="w-6/12">
        <div class="">
          <sepomex-address-form @onChange="addressChangedHandler"/>
        </div>
      </div>
    </div>
    <vs-button
        class="mt-4"
        @click="submitComplaint">
      Generar
    </vs-button>
  </div>
</template>
